import styled from "@emotion/styled";
import Button from "@mui/material/Button";

export const OrganizationSectionContainer = styled.div`
	display: flex;
	justify-content: space-between;
	margin: 4rem 8rem;
`;

export const OrganizationLeftSide = styled.div`
	display: flex;
	align-items: center;
`;

export const OrganizationImage = styled.div`
	padding: 0.8rem;
	border-radius: 12px;
	background-color: #5b7b9b;
	display: inline-block;
`;

export const OrganizationDescription = styled.div`
	margin: 1rem 1rem;
`;

export const OrganizationButton = styled(Button)`
	color: inherit;
	border-color: #a9a9a9;
	height: 2.5rem;
	align-self: center;
`;

export const OrganizationDescriptionName = styled.h2`
	color: #545351;
	margin-bottom: 1rem;
`;

export const OrganizationDescriptionNumContainer = styled.div`
	color: #545351;
	display: flex;
	align-items: center;
`;
